const PAGE_SIZE_OPTIONS = [5, 10, 20, 50];
const DEFAULT_PAGE_SIZE = 10;
const TAGS_RULES_ACCORDION_TABLE_PAGE_SIZE = 5;

export {
  PAGE_SIZE_OPTIONS,
  DEFAULT_PAGE_SIZE,
  TAGS_RULES_ACCORDION_TABLE_PAGE_SIZE
};
